import { put, take, call } from 'redux-saga/effects';
import {
  getChartsConfigurationSuccess,
  getChartsLinkedConfigurationSuccess,
  getDataChartConfigFile,
  setChartsConfigurationError,
} from '../../../reducers/dataConfigChartSlice';
import withLoading from '../../../sagas/loadingSaga';

export default function* dataChartConfigurationSaga(api) {
  while (true) {
    const getDataChartRequestedAction = yield take(getDataChartConfigFile.type);
    yield* withLoading(function* () {
      const { entityId } = getDataChartRequestedAction.payload;
      yield call(fetchChartsConfig, api, entityId);
    });
  }
}

function* fetchChartsConfig(api, entityId) {
  try {
    const chartData = yield call(api.getConfigDataForCharts, entityId);
    yield put(getChartsConfigurationSuccess(chartData.data.mainConfig));
    yield put(getChartsLinkedConfigurationSuccess(chartData.data.linkedConfig));
  } catch (error) {
    yield put(setChartsConfigurationError(error as string));
  }
}
